import React from 'react'
import { FunnelBarFill, FunnelBarTrack, FunnelStepRow, SectionCard, SectionTitle } from '../styles'
import { formatNumber, formatPercent } from '../utils'

const FunnelView = ({ steps = [], title = 'Funil de conversão' }) => {
    if (!steps?.length) {
        return (
            <SectionCard>
                <SectionTitle>{title}</SectionTitle>
                <div style={{ color: 'var(--text-tertiary)', fontSize: 14 }}>Sem dados de funil no período.</div>
            </SectionCard>
        )
    }

    const topUsers = steps[0]?.users || 0

    return (
        <SectionCard>
            <SectionTitle>{title}</SectionTitle>
            <FunnelStepRow style={{ fontSize: 12, color: 'var(--text-tertiary)', fontWeight: 700 }}>
                <div>#</div>
                <div>Etapa</div>
                <div>Usuários</div>
                <div>vs anterior</div>
                <div>vs topo</div>
            </FunnelStepRow>
            {steps.map((step) => {
                const pctOfTop = topUsers > 0 ? (step.users / topUsers) * 100 : 0
                return (
                    <FunnelStepRow key={`${step.step}-${step.metric}`}>
                        <div style={{ fontWeight: 700 }}>{step.step}</div>
                        <div>
                            <div style={{ fontWeight: 600, marginBottom: 4 }}>{step.label}</div>
                            <FunnelBarTrack>
                                <FunnelBarFill $pct={pctOfTop}>{formatNumber(step.users)}</FunnelBarFill>
                            </FunnelBarTrack>
                        </div>
                        <div>{formatNumber(step.users)}</div>
                        <div>
                            {step.conversionFromPrevious == null ? '—' : formatPercent(step.conversionFromPrevious)}
                        </div>
                        <div>{step.conversionFromTop == null ? '—' : formatPercent(step.conversionFromTop)}</div>
                    </FunnelStepRow>
                )
            })}
        </SectionCard>
    )
}

export default FunnelView
